import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconDownload } from "components/icons/Icons";
import { downloadFile } from "../helpers/documentHelpers";

interface OriginalFileCellProps {
  originFile: any;
}

export function OriginalFileCell({ originFile }: OriginalFileCellProps) {
  const textColor = useColorModeValue("black", "black");

  const handleDownload = () => {
    if (!originFile) return;

    const documentFilePath = originFile.document_file_path;
    const documentOriginalFileName = originFile.document_original_file_name;

    downloadFile(documentFilePath, documentOriginalFileName);
  };

  return (
    <Flex align="center">
      <Flex
        color={textColor}
        fontSize="14px"
        lineHeight="24px"
        fontWeight="400"
        alignItems={"center"}
        padding="5px 5px 5px 10px"
        borderRadius="100px"
        border="1px solid #E9E9E9"
      >
        <Box
          maxW="100px"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
        >
          {originFile ? originFile.document_original_file_name : ""}
        </Box>

        <Flex
          padding="5px 15px"
          background="#F3F5F5"
          borderRadius="20px"
          marginLeft="8px"
          cursor="pointer"
          onClick={handleDownload}
          _hover={{
            color: "#2F80ED",
            textDecoration: "underline",
          }}
        >
          <IconBox icon={<IconDownload width="24px" height="24px" />} />
          <Text
            fontSize={{ sm: "12px", lg: "14px" }}
            lineHeight="24px"
            fontWeight="400"
            color="#2F80ED"
            marginLeft="4px"
          >
            Download
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
